import StudentTransfer from '@/api/student-transfer'
import StudentProfile from '@/api/student-profile'
import AcademicClass from '@/api/class-operation'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  students: [],
  fromClasses: [],
  toClasses: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_STUDENTS(state, data) {
    state.students = data
  },
  RECEIVE_TO_CLASSES(state, data) {
    state.toClasses = data
  },
  RECEIVE_FROM_CLASSES(state, data) {
    state.fromClasses = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return StudentTransfer.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return StudentTransfer.store(data)
  },
  update(context, { transfer_id, ...data }) {
    return StudentTransfer.update(transfer_id, data)
  },
  destroy(context, id) {
    return StudentTransfer.destroy(id)
  },
  fetchStudent(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_student_profiles:
          'student_id,first_name_en,last_name_en,first_name_kh,last_name_kh,card_number,gender,ext_card_number'
      },
      ...attributes
    }

    return StudentProfile.get({ params }).then(response => {
      context.commit('SET_STUDENTS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchClass(context, attributes = {}) {
    return AcademicClass.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_classes:
            'class_id,class_name,ac_status_id,teacher_resp_id,ac_st_id'
        },
        filter: {
          class_of_current_grade: attributes.class_id,
          ac_status_id: [1]
        },
        include: 'academic_status,teacher,academic_study_time',
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_TO_CLASSES', response.data)
      return Promise.resolve(response)
    })
  },
  fetchCurrentClass(context, attributes = {}) {
    return AcademicClass.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_classes:
            'class_id,class_name,ac_status_id,teacher_resp_id,ac_st_id'
        },
        filter: {
          class_of_student: attributes.student_id,
          ac_status_id: [1]
        },
        include: 'academic_status,teacher,academic_study_time',
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_FROM_CLASSES', response.data)
      return Promise.resolve(response)
    })
  }
}
